import { type Tournament } from '@clubspark-node/clubspark-tennis-types';

import { type RankListResult } from 'components/panels/eventsSplitDraws/selectedEvent/utils';
import { RankingsAndRatingsRepositoryImpl } from 'repository/grapqhlRepository/rankingAndRatingsRepository';
import { type CloudResult, type RepositoryCacheType } from 'repository/repository';
import type RankingsAndRatingsService from 'services/rankingsAndRatings/rankingsAndRatingsService';
import { displayErrorMessage } from 'services/utils';
import { type PtResult } from 'typedefs/playTrackerTypes';
import { type RankListFilter } from 'typedefs/rankingsAndRatings';
import { type WtnResult } from 'typedefs/wtnTypes';

export class RankingsAndRatingsServiceImpl implements RankingsAndRatingsService {
  rankingsAndRatingsRepository = new RankingsAndRatingsRepositoryImpl();

  async getRankingsAndRatings(id: string, cache?: RepositoryCacheType): Promise<CloudResult<any>> {
    const rankingListAndRatings = await this.rankingsAndRatingsRepository.get(id, cache);

    // show toaster with error message if it exists
    displayErrorMessage<Tournament>(rankingListAndRatings);

    return Promise.resolve(rankingListAndRatings);
  }

  async getRankingList(
    id: string,
    itemPageArgs: { skip: number; limit: number },
    cache?: RepositoryCacheType,
  ): Promise<CloudResult<RankListResult[]>> {
    const rankingListResult = await this.rankingsAndRatingsRepository.getRankingList(id, itemPageArgs, cache);

    // show toaster with error message if it exists
    displayErrorMessage<Tournament>(rankingListResult);

    return Promise.resolve(rankingListResult);
  }

  async getRankingsList(
    ranklistFilter: RankListFilter,
    cache?: RepositoryCacheType,
  ): Promise<CloudResult<RankListResult>> {
    const rankingsListResult = await this.rankingsAndRatingsRepository.getRankingsList(ranklistFilter, cache);

    // show toaster with error message if it exists
    displayErrorMessage<RankListResult>(rankingsListResult);

    return Promise.resolve(rankingsListResult);
  }

  async getWtnRating(nationalIds: string[], cache?: RepositoryCacheType): Promise<CloudResult<WtnResult>> {
    const getWtnResult = await this.rankingsAndRatingsRepository.getWtnRating(nationalIds, cache);

    // show toaster with error message if it exists
    displayErrorMessage<WtnResult>(getWtnResult);

    return Promise.resolve(getWtnResult);
  }

  async getPtPoints(nationalIds: string[], cache?: RepositoryCacheType): Promise<CloudResult<PtResult>> {
    const getPtResult = await this.rankingsAndRatingsRepository.getPtPoints(nationalIds, cache);

    // show toaster with error message if it exists
    displayErrorMessage<PtResult>(getPtResult);

    return Promise.resolve(getPtResult);
  }
}
